import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "12",
  viewBox: "0 0 19 12",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M9.5.25C7.238.25 5.052 1.257 3.01 2.918a17.905 17.905 0 0 0-1.898 1.794l-.14.154-.24.275-.102.12-.229.286a.75.75 0 0 0 0 .906l.14.177.305.361.266.297c.56.611 1.195 1.222 1.898 1.794 2.042 1.661 4.227 2.668 6.488 2.668 2.262 0 4.447-1.007 6.49-2.668a17.903 17.903 0 0 0 1.898-1.794l.14-.154.24-.275.191-.229.14-.177a.75.75 0 0 0 0-.906l-.14-.177-.19-.229-.242-.275a17.91 17.91 0 0 0-2.038-1.948C13.946 1.257 11.76.25 9.5.25Zm0 1.5c1.858 0 3.742.868 5.542 2.332a16.424 16.424 0 0 1 1.739 1.643l.245.275-.245.275a16.416 16.416 0 0 1-1.739 1.643c-1.8 1.464-3.684 2.332-5.543 2.332-1.858 0-3.743-.868-5.542-2.332A16.41 16.41 0 0 1 2.22 6.275L1.972 6l.247-.275a16.419 16.419 0 0 1 1.739-1.643C5.757 2.618 7.64 1.75 9.499 1.75Z" }),
      _createElementVNode("path", { d: "M9.5 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Zm0 1.5a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5Z" })
    ], -1)
  ])))
}
export default { render: render }